import React from 'react';
import PropTypes from 'prop-types';

const PLACES = [
    { value: '', label: '—' },
    { value: '1', label: 'I' },
    { value: '2', label: 'II' },
    { value: '3', label: 'III' },
    { value: '4', label: 'IV' },
    { value: '5', label: 'V' },
    { value: '6', label: 'VI' },
    { value: '7', label: 'VII' },
    { value: '8', label: 'VIII' }
];

// Результаты одного мероприятия (.ev-res): места команд цветными селектами.
export default function EventResults({ event, onChangeResult }) {
    const results = event.teamCompetitionResultList || [];

    return (
        <div className="ev-res">
            <h4>{event.title}</h4>
            {results.length > 0 ? (
                <div className="ev-places">
                    {results.map(result => (
                        <div className="ev-place" key={result.id}>
                            <select
                                className="ev-sel"
                                style={{ '--tc': result.team?.color }}
                                value={String(result.result ?? '')}
                                onChange={(e) => onChangeResult(result.id, e.target.value)}
                            >
                                {PLACES.map(place => (
                                    <option key={place.value} value={place.value}>{place.label}</option>
                                ))}
                            </select>
                            <div className="lbl">{result.team?.name?.slice(0, 6) || '—'}</div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="t-caption">Нет результатов для команд</div>
            )}
        </div>
    );
}

EventResults.propTypes = {
    event: PropTypes.shape({
        title: PropTypes.string,
        teamCompetitionResultList: PropTypes.array
    }).isRequired,
    onChangeResult: PropTypes.func.isRequired
};
